var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import ResponsiveDialog from '../ResponsiveDialog/ResponsiveDialog';
import FileGrid from './FileGrid';
import FileGridItem from './FileGridItem';

var PhotoGalleryModal = function (_Component) {
    _inherits(PhotoGalleryModal, _Component);

    function PhotoGalleryModal() {
        var _temp, _this, _ret;

        _classCallCheck(this, PhotoGalleryModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            newSelection: [].concat(_this.props.selecteds)
        }, _this.handleSelectPhotos = function () {
            var newSelection = _this.state.newSelection;
            var onConfirm = _this.props.onConfirm;


            onConfirm(newSelection);
            _this.setState({ newSelection: [] });
        }, _this.createHandleFileChange = function (type, file) {
            return function () {
                _this.setState(function (state) {
                    var newSelection = type === 'ADD' ? [].concat(state.newSelection, [file]) : type === 'REMOVE' ? state.newSelection.filter(function (image) {
                        return image.id !== file.id;
                    }) : state.newSelection;

                    return { newSelection: newSelection };
                });
            };
        }, _this.renderFileItem = function (file, index) {
            var fileGridProps = {
                onActionClick: _this.createHandleFileChange('ADD', file),
                actionIcon: React.createElement(AddCircleOutlineIcon, { style: { color: '#fff' } })
            };

            if (file.selected) {
                fileGridProps = {
                    onActionClick: _this.createHandleFileChange('REMOVE', file),
                    actionIcon: React.createElement(CheckCircleIcon, { style: { color: '#fff' } })
                };
            }

            return React.createElement(FileGridItem, _extends({
                key: index,
                index: index,
                file: file
            }, fileGridProps));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    PhotoGalleryModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var selecteds = nextProps.selecteds;
        var newSelection = this.state.newSelection;

        var hasChangeSelecteds = JSON.stringify(selecteds) === JSON.stringify(newSelection);

        hasChangeSelecteds && this.setState({ newSelection: [].concat(selecteds) });
    };

    PhotoGalleryModal.prototype.getGalleryWithSelectedImages = function getGalleryWithSelectedImages() {
        var newSelection = this.state.newSelection;
        var gallery = this.props.gallery;

        var selectedIds = newSelection.map(function (file) {
            return file.id;
        });

        return gallery.map(function (image) {
            return _extends({}, image, { selected: selectedIds.includes(image.id) });
        });
    };

    PhotoGalleryModal.prototype.render = function render() {
        var _props = this.props,
            open = _props.open,
            gallery = _props.gallery,
            title = _props.title,
            onCancel = _props.onCancel;


        var galleryWithSelecteds = this.getGalleryWithSelectedImages();

        return React.createElement(
            ResponsiveDialog,
            {
                open: open,
                title: title,
                cancelText: 'Cancelar',
                okText: 'Confirmar',
                onCancel: onCancel,
                onOk: this.handleSelectPhotos
            },
            gallery.length ? React.createElement(FileGrid, {
                files: galleryWithSelecteds,
                render: this.renderFileItem
            }) : React.createElement(
                Typography,
                { type: 'body2' },
                'A galeria n\xE3o possui nenhuma imagem.'
            )
        );
    };

    return PhotoGalleryModal;
}(Component);

PhotoGalleryModal.defaultProps = {
    title: 'Galeria',
    open: false,
    gallery: [],
    selecteds: []
};

PhotoGalleryModal.propTypes = process.env.NODE_ENV !== "production" ? {
    open: PropTypes.bool.isRequired,
    gallery: PropTypes.array.isRequired,
    selecteds: PropTypes.array.isRequired,
    title: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
} : {};

export default PhotoGalleryModal;